<style scoped>
  .planBox {
    background-color: var(--color-background-dark);
    border-radius: 10px;
    cursor: pointer;
    /*height: 100%;*/
    width: 100%;
    height: 300px;
  }

  .selected {
    border: 3px solid var(--color-accent);
  }

  .month {
    text-align: center;
    font-size: 20px;
    /*font-weight: bold;*/
  }

  .cost {
    font-size: 32px;
    height: 50px;
    text-align: center;
  }

  .header {
    background-image: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
    height: 60px;
    width: 100%;
    margin: 0px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .discount-text {
    font-size: 14px;
    color: var(--color-text-dark);
    font-weight: bold;
  }

  .in-month-text {
    font-size: 18px;
    color: var(--color-neutral);
    display: inline-block;
    height: 40px;
    padding-top: 13px;
  }

  .priceBox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 136px;
    /*padding-top: 30px;*/
  }

  .footer {
    height: 20px;
    width: 100%;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .monthly {
    /*padding-top: 20px;*/
    text-align: center;
    height: 16px;
    margin-bottom: 5px;
  }

  .monthly-text {
    font-size: 14px;
    color: grey;
    /*font-weight: bold;*/
  }

  .bonus-text {
    font-size: 18px;
    display: inline-block;
    padding-left: 5px;
    background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  div {
    /*border: 1px dotted deeppink;*/
  }
</style>

<template>
<div class="planBox plan-card" :class="{'selected': $store.state.pay.selectedPeriod === period}">
  <div class="header">
    <div class="month">{{ period }} {{ $text.tr(monthText) }}</div>
  </div>
  <div style="height: 45px; padding-top: 8px">
<!--    <table v-if="bonusText !== ''" style="margin: 0 auto;">-->
<!--      <tr>-->
<!--        <td style="padding-left: 5px">-->
<!--          <img src="../../../assets/black-friday2.png" width="30px">-->
<!--        </td>-->
<!--        <td>-->
<!--          <div class="bonus-text">{{ bonusText }}</div>-->
<!--          <Tooltip max-width="290" placement="right-start" content="Акция действует до 02.12.2019 включительно. Бонус будет начислен в течении 24ч после оплаты">-->
<!--            <Icon style="color: #633cfc; margin-bottom: 2px; margin-left: 3px" type="ios-information-circle-outline"></Icon>-->
<!--          </Tooltip>-->
<!--        </td>-->
<!--      </tr>-->
<!--    </table>-->
  </div>
  <div class="priceBox">
      <div class="cost">${{ cost }}</div>
  </div>
<!--  <div v-if="discountUsd !== '0'" class="monthly monthly-text" style="font-size: 12px; padding-top: 16px">-->
<!--    АКЦИЯ ДЕЙСТВУЕТ ДО 2 ДЕКАБРЯ-->
<!--  </div>-->
  <div v-if="discountUsd !== '0'" class="monthly monthly-text">
    ${{ monthlyPrice }} / {{$text.tr('мес') }}
  </div>
  <div v-if="discountUsd !== '0'" class="footer">
      <div class="discount-text">{{ $text.tr('СКИДКА') }} ${{ discountUsd }} (-{{ discountPct }}%)</div>
  </div>
</div>
</template>

<script>
import Decimal from 'decimal.js'

export default {
  name: 'plan',
  props: ['period', 'cost'],
  data: function () {
    return {}
  },
  computed: {
    bonusText () {
      switch (this.period) {
        case '3':
          return '+1 месяц'
        case '6':
          return '+2 месяца'
        case '12':
          return '+4 месяца'
        default:
          return ''
      }
    },
    monthText () {
      switch (this.period) {
        case '1':
          return 'месяц'
        case '3':
          return 'месяца'
      }
      return 'месяцев'
    },
    monthPrice () {
      return 15
    },
    discountUsd () {
      return new Decimal(this.monthPrice).mul(this.period).sub(this.cost).toDP(0).toString()
    },
    discountPct () {
      return new Decimal(this.discountUsd).div(new Decimal(this.monthPrice).mul(this.period)).mul(100).toDP(0, Decimal.ROUND_DOWN).toString()
    },
    monthlyPrice () {
      return new Decimal(this.cost).div(this.period).toDP(1).toString()
    }
  },
  methods: {
  }
}
</script>
